// ============================================================
// 用户登录守卫组件
// ============================================================

import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useAuthStore } from '../stores/auth.store'
import { triggerLoginModal } from './LoginModal'

export default function AuthGuard() {
  const { isLoggedIn } = useAuthStore()

  useEffect(() => {
    if (!isLoggedIn) {
      triggerLoginModal()
    }
  }, [isLoggedIn])

  // 未登录时不渲染子路由，但也不跳转，由登录弹窗处理
  if (!isLoggedIn) {
    return null
  }

  return <Outlet />
}
